/**
 * Read the CSRF token from the XSRF-TOKEN cookie set by Inertia Rails.
 *
 * The <meta name="csrf-token"> tag is only rendered on full page loads and
 * goes stale during Inertia client-side navigation. The XSRF-TOKEN cookie,
 * however, is refreshed after every controller action, so it always matches
 * the current session.
 */
export function csrfToken(): string {
  const match = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : ""
}
